module.exports = __webpack_public_path__ + "static/media/group_copy_2@3x.bb7b6e7f.png";